import AboutPage from "~/landingPage/pages/aboutPage/AboutPage";
import InfluencersPage from "~/landingPage/pages/influencersPage/InfluencersPage";
import CompaniesPage from "~/landingPage/pages/companiesPage/CompaniesPage";
import ContactPage from "~/landingPage/pages/contactPage/ContactPage";
import RgpdPage from "~/landingPage/pages/rgpdPage/RgpdPage";
import CguPage from "~/landingPage/pages/cguPage/CguPage";

export default class LandingPagesRoutes {
  static public = [
    {
      key: "about",
      path: "",
      exact: true,
      component: AboutPage,
    },
    {
      key: "influencers",
      path: "influencers",
      exact: true,
      component: InfluencersPage,
    },
    {
      key: "companies",
      path: "companies",
      exact: true,
      component: CompaniesPage,
    },
    {
      key: "contact",
      path: "contact",
      exact: true,
      component: ContactPage,
    },
    {
      key: "rgpd",
      path: "rgpd",
      exact: true,
      component: RgpdPage,
    },
    {
      key: "cgu",
      path: "cgu",
      exact: true,
      component: CguPage,
    },
  ];
}
